const TOKEN_REGEX = /("(\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g;

const COLORS = {
  key: "#9cdcfe",
  string: "#ce9178",
  number: "#b5cea8",
  keyword: "#569cd6", // true, false, null
};

/**
 * Returns an HTML string with inline-colored spans for JSON tokens.
 * Intended for use with `dangerouslySetInnerHTML` inside a `<pre>`.
 */
export const syntaxHighlightJson = (obj: unknown, indent = 4): string => {
  const json = JSON.stringify(obj, null, indent) ?? "";
  return json.replace(TOKEN_REGEX, (match) => {
    let color = COLORS.number;
    if (match.startsWith('"')) {
      color = match.endsWith(":") ? COLORS.key : COLORS.string;
    } else if (/true|false|null/.test(match)) {
      color = COLORS.keyword;
    }
    return `<span style="color:${color}">${match}</span>`;
  });
};
